<template><div>

<v-btn @click="zaza"> Go </v-btn>
<v-btn @click="fafa"> T </v-btn>

<v-switch
  v-model="switch1"
  label="Change theme"
></v-switch>

</div></template>

<script>
/*
import { parse } from '@babel/parser';
import traverse from '@babel/traverse';
import generate from '@babel/generator';
import * as t from "@babel/types";

const code = `
class Car {
  constructor(n, y) {
    name = n;
    year = y;
  }
  age(x) {
    return x - year;
  }
}

(function() {
	let date = new Date();
	let year = date.getFullYear();

	let myCar = new Car("Ford", 2014);

	console.log(
	"My car is " + myCar.age(year) + " years old."
	)
})();
`;

const ast = parse(code, {sourceType: "module"});
console.log(ast);

let depth = 0;

traverse(ast, {
	StringLiteral(path) {
		if (path.node.value == 'fuck this') {
			console.log("Fuck this found!");
			path.remove();
		}
	},
	Identifier(path) {
		console.log(path.node);
		//if (depth == 0) return;
		if ( path.scope.hasBinding(path.node.name) ) return;
		if (['window', 'console', 'Date', 'localStorage', 'setTimeout', 'clearTimeout', 'setInterval', 'clearInterval', 'fetch'].includes(path.node.name)) return;
		if (path.parent.type == 'VariableDeclarator' && path.parent.id == path.node) return;
		if (path.parent.type == 'MemberExpression' && path.parent.property == path.node) return;
		if (['ObjectProperty', 'FunctionDeclaration', 'ClassMethod', 'MethodDefinition', 'FunctionExpression', 'ObjectMethod'].includes(path.parent.type)  ) return;
		path.replaceWith( t.memberExpression( t.thisExpression(), path.node) );
	}
});

const output = generate(ast, code);
console.log(output.code);
*/

let fuck_this;



export default {
	components: {},
	data() {
		return {
			msg: "Hello!",
			switch1: false,
		}
	},
	watch: {
		switch1() {
			this.$vuetify.theme.isDark = !this.$vuetify.theme.isDark;
		}
	},
	methods: {
		async zaza() {
			const result = await Notification.requestPermission();
			if (result === 'granted') {
				const noti = new Notification('Hello!', {
					body: 'It’s me.',
					icon: 'favicon.png'
				});
				noti.onclick = () => alert('clicked');
			}
		},
		fafa() {
			console.log(Object);
		}
	},
}

</script>
